import "core-js/modules/es.array.find.js";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { Flex } from '@chakra-ui/react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { generateUtmUrl } from '@aftersale-next/utils';
import { useEcommerceName, useEcommerceUrlSettings, useEcommerceImages } from '@aftersale-next/atoms';
export var EcommerceLogo = function EcommerceLogo() {
  var _images$find, _urlSettings$utm;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useEcommerceName = useEcommerceName(),
      _useEcommerceName2 = _slicedToArray(_useEcommerceName, 1),
      name = _useEcommerceName2[0];

  var _useEcommerceUrlSetti = useEcommerceUrlSettings(),
      _useEcommerceUrlSetti2 = _slicedToArray(_useEcommerceUrlSetti, 1),
      urlSettings = _useEcommerceUrlSetti2[0];

  var _useEcommerceImages = useEcommerceImages(),
      _useEcommerceImages2 = _slicedToArray(_useEcommerceImages, 1),
      images = _useEcommerceImages2[0];

  var logoUrl = images === null || images === void 0 ? void 0 : (_images$find = images.find(function (img) {
    return img.type === 'logo';
  })) === null || _images$find === void 0 ? void 0 : _images$find.url;
  var baseUrl = urlSettings.url ? "https://".concat(urlSettings.url) : '';
  var ecommerceUrl = urlSettings !== null && urlSettings !== void 0 && (_urlSettings$utm = urlSettings.utm) !== null && _urlSettings$utm !== void 0 && _urlSettings$utm.utmMainLogo ? generateUtmUrl({
    baseUrl: baseUrl,
    source: t('UTM_SOURCE'),
    medium: urlSettings.utm.utmMainLogo,
    campaign: t('UTM_CAMPAIGN')
  }) : baseUrl;

  if (!logoUrl) {
    return /*#__PURE__*/_jsx("h1", {
      children: name
    });
  }

  if (!name) {
    return /*#__PURE__*/_jsx(Fragment, {});
  }

  return /*#__PURE__*/_jsx(Flex, {
    justify: "center",
    my: "32px",
    children: /*#__PURE__*/_jsx("a", {
      href: ecommerceUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      "data-testid": "ecommerce-url",
      children: /*#__PURE__*/_jsx("img", {
        "data-testid": "ecommerce-logo",
        height: "100%",
        style: {
          width: '12rem'
        },
        src: logoUrl,
        alt: name,
        title: name
      })
    })
  });
};